// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';
import { ROUTE_API } from 'configs';
import { NotificationProps } from 'types/notifications';
import _ from 'lodash';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['notification'] = {
    open: false,
    total: 0,
    totalUnread: 0,
    notifications: []
};

const slice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setOpenSuccess(state, action) {
            state.open = action.payload;
        },
        setTotalSuccess(state, action) {
            state.total = action.payload;
        },
        setNoUnreadSuccess(state, action) {
            state.totalUnread = action.payload;
        },
        plusNoUnreadSuccess(state, action) {
            state.totalUnread = state.totalUnread + action.payload;
        },
        minuteNoUnreadSuccess(state, action) {
            const id = action.payload === 'all' ? 'all' : parseInt(action.payload);
            if (id !== 'all') {
                const itemIndex = _.findIndex(state.notifications, { id: id });
                if (itemIndex !== -1) {
                    state.notifications[itemIndex].is_read = 1;
                }
                state.totalUnread = state.totalUnread - 1;
            } else {
                state.notifications = _.map(state.notifications, item => ({ ...item, is_read: 1 }));
                state.totalUnread = 0;
            }

        },
        fetchNotificationsSuccess(state, action) {
            state.notifications = action.payload;
        },

    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchNotifications(page: number = 1) {
    return async () => {
        try {
            const param_search = {
                page: page,
                perpage: 5,
            };
            const res = await axios.get(ROUTE_API.notification.list, { params: param_search, headers: { cursorLoading: false } });
            const { ErrorCode, Data } = res.data;
            if (ErrorCode === 0) {
                dispatch(slice.actions.fetchNotificationsSuccess(Data.data));
                dispatch(slice.actions.setTotalSuccess(Data.total));
                dispatch(slice.actions.setNoUnreadSuccess(Data.count_unread));
            }
        } catch (error) {
            dispatch(slice.actions.fetchNotificationsSuccess([]));
        }
    };
}

export function setOpen(value: boolean) {
    return () => {
        dispatch(slice.actions.setOpenSuccess(value))
    };
}

export function setRead(id: string) {
    return async () => {
        try {
            const res = await axios.post(ROUTE_API.notification.update, { notification_id: id });
            const { ErrorCode } = res.data;
            if (ErrorCode === 0) {
                dispatch(slice.actions.minuteNoUnreadSuccess(id));
            }
        } catch (error) {
            // dispatch(slice.actions.isOpen(error));
        }
    };
}
